<template>
  <div class="page-table scrollable only-y mainDiv mb-30">
    <div class="card-base baslikBg animated fadeInUp">Evrak Listesi
      <div class="tanimlamaButon">
        <el-tooltip :content='$t("src.views.apps.genel.yeniKaydet")' :open-delay="500" placement="top"
                    v-if="yetkiTuru != '3'">
          <el-button v-on:click="routeCari('Evrak Tanımla')" size="mini" type="text"
                     icon="el-icon-plus"></el-button>
        </el-tooltip>
        <el-tooltip :content='$t("src.views.apps.genel.refresh")' :open-delay="500" placement="top">
          <el-button v-on:click="refreshPage()" style="margin-left: 15px !important" type="text"
                     icon="el-icon-refresh"></el-button>
        </el-tooltip>
      </div>
    </div>
    <div class="page-header card-base card-shadow--medium animated fadeInUp"
         v-loading="loading || searchLoading || konuLoading || cariLoading || addLoading || evrakLoading"
         :element-loading-text='loading ? "Evrak Listesi Getiriliyor. Lütfen Bekleyiniz." : searchLoading ? "Evrak Aranıyor. Lütfen Bekleyiniz." : konuLoading ? "Evrak Konu Güncelleniyor. Lütfen Bekleyiniz."
                : addLoading ? "Boş Evrak Ekleniyor. Lütfen Bekleyiniz." : cariLoading ? "Evrak Listesi Getiriliyor. Lütfen Bekleyiniz." : addLoading ? "Evrak Siliniyor. Lütfen Bekleyiniz." : "Evrak Yükleniyor. Lütfen Bekleyiniz."'
         element-loading-spinner="el-icon-loading" element-loading-background="rgba(255, 255, 255, 1)">
      <el-row class="mt-0 mb-10">
        <el-col :lg="12" :md="12" :sm="24" :xs="24">
          <el-radio-group v-on:change="handleChange($event)" v-model="radio" size="medium">
            <el-badge :value="gelenCount" class="item evrak">
              <el-radio-button label="1" class="gelen">Gelen Evraklar
              </el-radio-button>
            </el-badge>
            <el-badge :value="gidenCount" class="item evrak">
              <el-radio-button label="2" class="giden">Giden Evraklar
              </el-radio-button>
            </el-badge>
          </el-radio-group>
        </el-col>
        <el-col :lg="12" :md="12" :sm="24" :xs="24" v-if="yetkiTuru != '3'">
          <el-col :lg="24" :md="24" :sm="24" :xs="24">
            <ul class="islemler">
              <li>
                <i class="mdi mdi-download mdi-18px" style="color: #036fad"></i>
                <span>Evrak İndir</span>
              </li>
              <li>
                <i class="mdi mdi-account mdi-18px" style="color: #5c5c61"></i>
                <span>Yetkili Görüntüle</span>
              </li>
              <li>
                <i class="mdi mdi-pen mdi-18px" style="color: #f7ba2a"></i>
                <span>Evrak Güncelle</span>
              </li>
              <li>
                <i class="mdi mdi-delete mdi-18px" style="color: #ec205f "></i>
                <span>Evrak Sil</span>
              </li>
            </ul>
          </el-col>
        </el-col>
      </el-row>
      <el-table v-loading="searchLoading" border stripe :data="evrakListe" style="width: 100%"
                :element-loading-text='"Evrak Aranıyor. Lütfen bekleyin."' element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 1)">
        <el-table-column>
          <el-table-column v-if="false" label='Dosya' align="left" width="150">
            <template slot-scope="scope">
              <div>
                <el-tooltip v-if="scope.row.dosyaAdi != '' && scope.row.dosyaAdi !== null" content='İndir'
                            :open-delay="500" placement="bottom">
                  <el-button @click="downloadFile(scope.row);" class="download-btn" type="primary"><i
                      class="mdi mdi-download mdi-20px"></i></el-button>
                </el-tooltip>
                <el-tooltip v-if="false && scope.row.dosyaAdi == null" content='Dosya Yükle'
                            :open-delay="500" placement="bottom" class="upload-tooltip">
                  <el-upload class="upload"
                             :file-list="evrakListMain.findIndex(item=> item.yaziIsleriID == scope.row.yaziIsleriID) != -1 ? evrakListMain : []"
                             :id="'evrakEkle_' + scope.row.yaziIsleriID" action="" :auto-upload="false" :limit="1"
                             :on-change="file => evrakUpload(file, scope.row)"
                             :on-remove="evrakRemove" list-type="belge-card" accept="">
                    <el-button :loading="guncellenenID == scope.row.yaziIsleriID" v-if="yetkiTuru != '3'"
                               class="upload-btn"
                               type="primary">
                      <i v-if="guncellenenID != scope.row.yaziIsleriID" class="mdi mdi-cloud-upload mdi-20px"/>
                    </el-button>
                  </el-upload>
                </el-tooltip>
                <el-popover v-if="scope.row.dosyaAdi == null" placement="right" width="180" trigger="click">
                  <el-upload class="upload"
                             :file-list="evrakListMain.findIndex(item=> item.yaziIsleriID == scope.row.yaziIsleriID) != -1 ? evrakListMain : []"
                             :id="'evrakEkle_' + scope.row.yaziIsleriID" action="" :auto-upload="false" :limit="1"
                             :on-change="file => evrakUpload(file, scope.row)"
                             :on-remove="evrakRemove" list-type="belge-card" accept="">
                    <el-button size="mini" :loading="guncellenenID == scope.row.yaziIsleriID" v-if="yetkiTuru != '3'"
                               type="primary" style="margin:5px;background-color: #008DDA">
                      PC den Dosya Ekle
                    </el-button>
                  </el-upload>
                  <el-button @click="dosyaEvrakAtama(scope.row.yaziIsleriID)"
                             style="margin:5px;background-color: #008DDA" size="mini"
                             type="danger">
                    Sunucudan Seç
                  </el-button>
                  <el-button slot="reference" :loading="guncellenenID == scope.row.yaziIsleriID" v-if="yetkiTuru != '3'"
                             class="upload-btn"
                             type="primary">
                    <i v-if="guncellenenID != scope.row.yaziIsleriID" class="mdi mdi-cloud-upload mdi-20px"/>
                  </el-button>
                </el-popover>
              </div>
            </template>
          </el-table-column>
          <el-table-column label='Dosya' align="left" width="150">
            <template slot-scope="scope">
              <div>
                <el-tooltip v-if="scope.row.dosyaAdi != '' && scope.row.dosyaAdi !== null" content='İndir'
                            :open-delay="500" placement="bottom">
                  <el-button @click="downloadFile(scope.row);" class="download-btn" type="primary"><i
                      class="mdi mdi-download mdi-20px"></i></el-button>
                </el-tooltip>
                <el-tooltip v-if="scope.row.dosyaAdi == null" content='Dosya Yükle'
                            :open-delay="500" placement="bottom" class="upload-tooltip">
                  <el-upload class="upload"
                             :file-list="evrakListMain.findIndex(item=> item.yaziIsleriID == scope.row.yaziIsleriID) != -1 ? evrakListMain : []"
                             :id="'evrakEkle_' + scope.row.yaziIsleriID" action="" :auto-upload="false" :limit="1"
                             :on-change="file => evrakUpload(file, scope.row)"
                             :on-remove="evrakRemove" list-type="belge-card" accept="">

                    <el-button :loading="guncellenenID == scope.row.yaziIsleriID" v-if="yetkiTuru != '3'"
                               class="upload-btn"
                               type="primary">
                      <i v-if="guncellenenID != scope.row.yaziIsleriID" class="mdi mdi-cloud-upload mdi-20px"/>
                    </el-button>
                  </el-upload>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column>
          <template slot="header" slot-scope="props">
            <el-input clearable v-on:clear="evrakAra" placeholder='Evrak No Ara' v-model="evrakNoAra"
                      v-debounce:500ms="evrakAra" size="mini"></el-input>
          </template>
          <el-table-column prop="kayitKodu" label='Evrak No' width="200" :formatter="formatEvrakNo">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.newRow">{{ yeniKayitKodu }}</span>
                <span v-else>{{ formatEvrakNo(scope.row) }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column>
          <template slot="header" slot-scope="props">
            <el-input clearable v-on:clear="evrakAra" placeholder='Evrak Konu Ara' v-model="evrakKonuAra"
                      v-debounce:500ms="evrakAra" size="mini"></el-input>
          </template>
          <el-table-column prop="konu" label="Evrak Konu" width="auto">
            <template slot-scope="scope">
              {{ scope.row.konu }}
              <div v-if="false">
                <div v-if="!tiklama && !scope.row.newRow" class="" @dblclick="editKonu(scope.row)">
                  {{ scope.row.konu }}
                </div>
                <div v-if="tiklama">
                  <el-input v-model="scope.row.konu" size="mini" @blur="saveEditedKonu(scope.row)">
                  </el-input>
                </div>
                <div v-if="scope.row.newRow && !onaylaEvrakKonuTiklandi">
                  <el-col :lg="20">
                    <el-input style="width: 90%" placeholder='Evrak Konu Giriniz' v-model="scope.row.konu"
                              size="mini"></el-input>
                  </el-col>
                  <el-col :lg="2">
                    <el-tooltip content='Onayla' :open-delay="500" placement="bottom">
                      <el-button @click="onaylaEvrakKonu" type="primary" size="small"
                                 icon="el-icon-check"></el-button>
                    </el-tooltip>
                  </el-col>
                </div>
                <div class="new-line-text" v-if="scope.row.newRow && onaylaEvrakKonuTiklandi">
                  <span>{{ scope.row.konu }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column>
          <template slot="header" slot-scope="props">
            <el-input clearable v-on:clear="evrakAra" placeholder='Cari Ara' v-model="cariAra"
                      v-debounce:500ms="evrakAra" size="mini"></el-input>
          </template>
          <el-table-column prop="cariAdi" label="Cari Adı" width="auto">
            <template slot-scope="scope">
              <div v-if="scope.row.newRow && !onaylaCariTiklandi" class="new-line-text">
                <el-col :lg="20">
                  <el-select ref="cariSelect" style="width: 90%" size="small" v-model="scope.row.cariAdi"
                             placeholder="Cari Seçiniz" filterable :filter-methos="filterMethod">
                    <el-option v-for="item in cariListe" :key="item.cariID" :label="item.cariAdi"
                               :value="item.cariAdi">
                    </el-option>
                  </el-select>
                </el-col>
                <el-col :lg="2">
                  <el-tooltip content='Onayla' :open-delay="500" placement="bottom">
                    <el-button @click="onaylaCari" type="primary" size="small"
                               icon="el-icon-check"></el-button>
                  </el-tooltip>
                </el-col>
              </div>
              <div class="new-line-text" v-if="scope.row.newRow && onaylaCariTiklandi">
                <span>{{ scope.row.cariAdi }}</span>
              </div>
              <div class="new-line-text" v-if="!scope.row.newRow">
                <span>{{ scope.row.cariAdi }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column>
          <template slot="header" slot-scope="props">
            <el-date-picker @change="evrakAra" placeholder='Tarih Ara' v-model="tarihAra" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" :picker-options="{ firstDayOfWeek: 1 }" size="mini"
                            class="select-wide" type="date"></el-date-picker>
          </template>
          <el-table-column prop="islemTarihi" label='Evrak Tarihi' width="300">
            <template slot-scope="scope">
              <div v-if="scope.row.newRow && !onaylaTarihTiklandi">
                <el-col :lg="20">
                  <el-date-picker style="width: 90%;" v-model="scope.row.islemTarihi" size="small"
                                  class="select-wide" type="date" :placeholder='"Tarih Seçiniz"' format="dd.MM.yyyy"
                                  value-format="yyyy-MM-dd" :picker-options="{ firstDayOfWeek: 1 }">
                  </el-date-picker>
                </el-col>
                <el-col :lg="2">
                  <el-tooltip content='Onayla' :open-delay="500" placement="bottom">
                    <el-button @click="onaylaTarih" type="primary" size="small"
                               icon="el-icon-check"></el-button>
                  </el-tooltip>
                </el-col>
              </div>
              <div v-else>
                <span>{{ formatDate2(scope.row.islemTarihi) }}</span>
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column v-if="yetkiTuru != '3'">
          <el-table-column :label='$t("src.views.apps.genel.islem")' align="right" width="200">
            <template slot-scope="scope">
              <el-tooltip :content="scope.row.olusturan + ' - ' + formatDate2(scope.row.islemTarihi)"
                          :open-delay="500" placement="bottom" v-if="!scope.row.newRow">
                <el-button type="text" style="color:#5c5c61; margin-left: 15px !important;"
                           icon="mdi mdi-account mdi-24px">
                </el-button>
              </el-tooltip>
              <el-tooltip content='Evrak Güncelle' :open-delay="500" placement="bottom"
                          v-if="!scope.row.newRow">
                <el-button v-if="yetkiTuru == 1 || (yetkiTuru == 2 && sonDosyaID == scope.row.yaziIsleriID)"
                           v-on:click="updatePage(scope.row);" type="text"
                           style="color: #f7ba2a; margin-left: 15px !important;" icon="mdi mdi-pen mdi-24px">
                </el-button>
              </el-tooltip>
              <el-tooltip :content='$t("src.views.apps.rakamlar.islem.sil")' :open-delay="500"
                          placement="bottom" v-if="!scope.row.newRow">
                <el-button v-if="yetkiTuru == 1 || (yetkiTuru == 2 && sonDosyaID == scope.row.yaziIsleriID)"
                           v-on:click="dosyaSil(scope.row.yaziIsleriID,scope.row.dosyaDurumu)" type="text"
                           class="buttonDel"
                           style="margin-left: 15px !important;" icon="mdi mdi-trash-can mdi-24px"
                           :loading="silinenID.includes(scope.row.yaziIsleriID)">
                </el-button>
              </el-tooltip>
              <el-tooltip content='Boş Evrak Ekle' :open-delay="500" v-if="scope.row.newRow">
                <el-button
                    v-on:click="bosEvrakTanimla(scope.row.konu, scope.row.cariAdi, scope.row.islemTarihi)"
                    size="small" type="primary"
                    style="margin-left: auto; margin-right: 0; margin-top: 5px; margin-bottom: 5px; display: block; text-align: right;">
                  Kaydet
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
      <div v-if="evrakListe.length == []"
           style="width: 100%; height: 50px !important; display: flex; justify-content: center; align-items: center">
        {{ $t("src.views.apps.messages.noData") }}
      </div>
      <el-row>
        <!--
        <el-col :lg="12" :md="12" :sm="12" :xs="12" >
            <el-button size="small" type="primary" style="margin: 10px;" @click="addRow">+</el-button>
        </el-col>
        -->
        <el-col :lg="24" :md="24" :sm="24" :xs="24">
          <el-pagination background layout="sizes,prev, pager, next, jumper, total" :total="total"
                         @size-change="handleSizeChange" @current-change="pageChange" :page-sizes="[20, 50, 100]"
                         :current-page.sync="page" :next-click.sync="page" :prev-click.sync="page"
                         @next-click="pageChange"
                         @prev-click="pageChange">
          </el-pagination>
        </el-col>
      </el-row>
    </div>
    <el-dialog title="Sunucudan Dosya Seç" :visible.sync="dialogVisible" width="60%" class="sunucu-dialog">
      <el-row>
        <el-col :span="24" class="mb-10">
          <el-input v-on:clear="suncuDosyaSearch" clearable v-model="sunucuDosyaSearch" size="mini"
                    v-debounce:100ms="suncuDosyaSearch" placeholder="Dosya Adını Giriniz" style="width: 30%"/>
        </el-col>
      </el-row>
      <el-row v-if="sunucuDosyaList.length > 0">
        <div class="scrollable only-y" style="max-height: 600px !important;">
          <el-col v-for="(item,i) in sunucuDosyaList" :key="i" :span="4" class="text-center mt-30">
            <el-image
                @click="dosyaYukleEvrakData.dosyaID != item.dosyaID ? dosyaYukleEvrakData.dosyaID = item.dosyaID : dosyaYukleEvrakData.dosyaID = ''"
                :src="item.dosyaYolu"
                style="width: 110px; height: 110px;cursor: pointer"
                :style="{filter: dosyaYukleEvrakData.dosyaID == item.dosyaID ? 'brightness(0.5)' :''}"/>
            <p class="m-0">{{ item.dosyaYolu }}</p>
          </el-col>
        </div>
      </el-row>
      <el-row v-else>
        <h3 class="m-0">Sunucuda Dosya Bulunamadı</h3>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="sunucuDialogClosed">Kapat</el-button>
        <el-button :disabled="dosyaYukleEvrakData.dosyaID == ''" type="primary"
                   @click="sunucudanDosyaYukle()">Kaydet</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cariService from '../../../WSProvider/CariService'
import dosyaService from '../../../WSProvider/DosyaService'
import EventBus from '@/components/event-bus'
import notification from '../../../notification'
import functions from '../../../functions'
import evrakService from '../../../WSProvider/EvrakService'
import $ from 'jquery'

var moment = require('moment');

export default {
  name: "EvrakListesi",
  data() {
    return {
      sunucuDosyaSearch: '',
      dosyaYukleEvrakData: {
        yaziIsleriID: '',
        dosyaID: '',
        dosyaAdi: '',
      },
      sunucuDosyaList: [],
      initialSunucuDosyaList: [],
      dialogVisible: false,
      guncellenenID: null,
      silinenID: [],
      selectIcon: '1',
      loading: false,
      stateLoading: false,
      searchLoading: false,
      cariLoading: false,
      evrakLoading: false,
      addLoading: false,
      tiklama: false,
      konuLoading: false,
      onaylaCariTiklandi: false,
      onaylaEvrakKonuTiklandi: false,
      onaylaTarihTiklandi: false,
      addTiklandi: false,
      dosyaYukleme: false,
      //editDialogLoading: false,
      editDialog: false,
      editDialogData: {},
      musteriList: [],
      evrakListe: [],
      cariListe: [],
      evrakListMain: [],
      radio: '1',
      evrakForm: {
        evrakTarihi: "",
        durum: '1',
        cariID: "",
        evrak: [],
        evrakID: '',
        evrakAdi: ''
      },
      rulesMusteri: {},
      sizes: 20,
      evrakDurumu: '1',
      cariDurumu: "",
      evrakKonu: "",
      page: 0,
      postPage: 0,
      yetkiTuru: "",
      total: 4,
      evrakNoAra: "",
      evrakKonuAra: "",
      cariAra: "",
      tarihAra: "",
      evrakAdiAra: "",
      yeniKayitKodu: "",
      gelenCount: "",
      gidenCount: "",
      sonDosyaID: "",
      secilenCari: ""
    }
  },
  created() {
    if (localStorage.getItem("userDataDemirag")) {
      this.yetkiTuru = this.$store.getters.getYetkiTuru;
    }
    EventBus.$on("evrakList", (durum) => {
      this.refreshPage(durum)
    });
  },
  mounted() {
    //this.getMusteriListesi();
    //this.getMusteriProjeListesi();
    this.yetkiTuru = this.$store.getters.getYetkiTuru
    this.getDosyaList();
  },
  methods: {
    sunucuDialogClosed() {
      this.dialogVisible = false
      this.dosyaYukleEvrakData.yaziIsleriID = ''
      this.dosyaYukleEvrakData.dosyaID = ''
      this.dosyaYukleEvrakData.dosyaAdi = ''
      this.sunucuDosyaSearch = ''
      this.sunucuDosyaList = this.initialSunucuDosyaList
    },
    suncuDosyaSearch() {
      const self = this
      if (this.sunucuDosyaSearch != '') this.sunucuDosyaList = this.initialSunucuDosyaList.filter(item => item.dosyaYolu.toLowerCase().includes(self.sunucuDosyaSearch.toLowerCase()))
      else this.sunucuDosyaList = this.initialSunucuDosyaList
    },
    sunucudanDosyaYukle() {
      evrakService.evrakSunucudanDosyaYukle(this.dosyaYukleEvrakData.yaziIsleriID, this.dosyaYukleEvrakData.dosyaID).then((response) => {
        if (response.status == 200) {
          localStorage.setItem("userDataDemirag", response.token);
          this.dialogVisible = false
          this.getDosyaList();
        } else notification.Status("errorMsg", this, response.msg || response.errMsg)
      }).catch(err => {
        if (err.responseJSON) {
          let error = err.responseJSON
          if (error.status == 401) {
            notification.Status(150, this);
          } else notification.Status("errorMsg", this, error.msg || error.errMsg)
        }
      })
    },
    dosyaEvrakAtama(yaziIsleriID) {
      this.getSunucuDosyaList()
      this.dosyaYukleEvrakData.yaziIsleriID = yaziIsleriID
      this.dialogVisible = true
    },
    getSunucuDosyaList() {
      evrakService.sunucuDosyaList().then((response) => {
        if (response.status == 200) {
          localStorage.setItem("userDataDemirag", response.token);
          this.sunucuDosyaList = response.data;
          this.initialSunucuDosyaList = response.data;
        }
      }).catch(err => {
        if (err.responseJSON) {
          let error = err.responseJSON
          if (error.status == 401) {
            notification.Status(150, this);
          } else if (error.status == 404) {
            this.sunucuDosyaList = [];
            this.initialSunucuDosyaList = [];
          } else notification.Status("errorMsg", this, error.errMsg)
        }
      })
    },
    compileEvrakDurum(durum) {
      console.log(durum)
      this.selectIcon = durum
    },
    evrakUpload(file, row, formName) {
      this.$set(row, 'dosyaYuklendi', true);
      const item = {
        name: file.name,
        url: file.url,
        id: file.raw.lastModified,
        size: file.raw.size,
        yaziIsleriID: row.yaziIsleriID,
      };
      this.evrakListMain.push(item)
      file.raw["tmp_name"] = file.url;
      this.evrakForm.evrak.push(file.raw);
      this.$forceUpdate();
      //row.dosyaYuklendi = false;
      this.$confirm("Evrak Eklemek İstediğinize Emin Misiniz?", this.$t("src.views.apps.genel.uyari"), {
        confirmButtonText: this.$t("src.views.apps.genel.yes"),
        cancelButtonText: this.$t("src.views.apps.genel.no"),
        type: 'warning'
      }).then(() => {
        this.guncellenenID = row.yaziIsleriID
        // this.evrakLoading = true;
        dosyaService.dosyaGuncelle(row.yaziIsleriID, row.cariID, row.konu, this.evrakForm.evrak[0]).then((response) => {
          if (response.status == 200) {
            localStorage.setItem("userDataDemirag", response.token)
            notification.Status("success", this, response.msg)
            this.evrakListe.forEach(item => {
              if (item.yaziIsleriID == row.yaziIsleriID) item.dosyaAdi = response.data.dosyaAdi
            })
            // this.refreshPage(row.dosyaDurumu)
            this.resetForm(formName)
          }
          // this.evrakLoading = false;
        }).catch(err => {
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else notification.Status("errorMsg", this, error.errMsg)
          } else {
            //notification.Status(503, this)
          }
          // this.evrakLoading = false;
        }).finally(() => {
          const findIndex = this.evrakListMain.findIndex(item => item.yaziIsleriID == row.yaziIsleriID)
          this.evrakListMain.splice(findIndex, 1)
          this.evrakForm.evrak = []
          this.guncellenenID = null
        })
      }).catch((e) => {
        const findIndex = this.evrakListMain.findIndex(item => item.yaziIsleriID == row.yaziIsleriID)
        this.evrakListMain.splice(findIndex, 1)
        this.evrakForm.evrak = []
      })
    },
    editKonu(row) {
      this.tiklama = true;
      row.editing = true;
    },
    onaylaCari() {
      this.onaylaCariTiklandi = true
      this.secilenCari = this.$refs.cariSelect.selectedLabel;
    },
    onaylaEvrakKonu() {
      this.onaylaEvrakKonuTiklandi = true
      //this.secilenCari = this.$refs.cariSelect.selectedLabel;
    },
    onaylaTarih() {
      this.onaylaTarihTiklandi = true
      //this.secilenCari = this.$refs.cariSelect.selectedLabel;
    },
    saveEditedKonu(row) {
      this.tiklama = false;
      row.editing = false;

      this.konuLoading = true;
      dosyaService.dosyaGuncelle2(row.yaziIsleriID, row.konu).then((response) => {
        if (response.status == 200) {
          localStorage.setItem("userDataDemirag", response.token)
        }
        this.konuLoading = false;
        notification.Status("success", this, response.msg)
      }).catch(err => {
        if (err.responseJSON) {
          let error = err.responseJSON
          if (error.status == 401) {
            notification.Status(150, this);
          } else notification.Status("errorMsg", this, error.errMsg)
        } else {
          //notification.Status(503, this)
        }
        this.konuLoading = false;
      })
    },
    addRow() {
      this.addTiklandi = true
      if (this.evrakListe.length != 0) {
        let maxSiraNo = Math.max(...this.evrakListe.map((evrak) => evrak.yaziIsleriID), 0);
        let foundEvrak = this.evrakListe.find((evrak) => evrak.yaziIsleriID == maxSiraNo);
        let kayitKodu = foundEvrak ? this.formatEvrakNo(foundEvrak) : null;
        const numberPart = parseInt(kayitKodu.substring(1));
        const charPart = kayitKodu.substring(0, 1);
        const yeniKayitKodu = `${charPart}${numberPart + 1}`;
        this.yeniKayitKodu = yeniKayitKodu
        this.evrakListe.push({newRow: true, dosyaAdi: ''});
        this.getCariList();
      } else {
        const yeniKayitKodu = `${this.evrakDurumu}1`;
        this.yeniKayitKodu = yeniKayitKodu
        this.evrakListe.push({newRow: true, dosyaAdi: ''});
        this.getCariList();
      }

    },
    bosEvrakTanimla(evrakKonu, cari, tarih) {
      if (evrakKonu != undefined && !this.onaylaEvrakKonuTiklandi) {
        notification.Status("warning", this, "Lütfen evrak konusunu onaylayınız.")
        this.addLoading = false;
        return;
      } else if (cari != undefined && !this.onaylaCariTiklandi) {
        notification.Status("warning", this, "Lütfen cariyi onaylayınız.")
        this.addLoading = false;
        return;
      } else if (tarih != undefined && !this.onaylaTarihTiklandi) {
        notification.Status("warning", this, "Lütfen tarihi onaylayınız.")
        this.addLoading = false;
        return;
      } else if (tarih == "" || tarih == undefined || !tarih) {
        notification.Status("warning", this, "Lütfen tarih seçiniz.")
        this.addLoading = false;
        return;
      }
      this.openConfirmDialog("Boş evrak eklemek istediğinize emin misiniz?").then(() => {
        try {
          this.addLoading = true;
          dosyaService.bosDosyaEkle(this.evrakDurumu, this.evrakForm.evrak[0] != undefined ? this.evrakForm.evrak[0] : "", evrakKonu != undefined ? evrakKonu : "", cari != undefined ? cari : "", tarih != undefined ? tarih : "").then(response => {

            if (response.status == 200) {
              localStorage.setItem("userDataDemirag", response.token)
              notification.Status("success", this, response.msg)
              this.refreshPage();
              this.resetForm(formName)
            }
            this.addLoading = false;
          }).catch(err => {
            if (err.responseJSON) {
              let error = err.responseJSON
              console.log(error)
              if (error.status == 401) {
                notification.Status(150, this);
              } else {
                if (error.status == 400) {
                  notification.Status("warning", this, error.errMsg)
                }
                if (error.status == 503) {
                  notification.Status("warning", this, error.msg)
                }
              }
            } else {
              //notification.Status(503, this)
            }
            this.addLoading = false;
          })
        } catch (e) {
          this.addLoading = false;
        }
      })
    },
    getDosyaList(durum) {
      try {
        this.loading = true;
        this.evrakDurumu == 2 ? this.evrakDurumu = "O" : this.evrakDurumu = "I"
        if (durum) {
          this.evrakDurumu = durum
          this.evrakDurumu === 'O' ? this.radio = 2 : this.radio = 1
        }
        evrakService.evrakListele({
          baslangic: this.postPage,
          limit: this.sizes,
          // durum: this.evrakDurumu,
          dosyaDurumu: durum || this.evrakDurumu,
        }).then((response) => {
          if (response.status == 200) {
            localStorage.setItem("userDataDemirag", response.token);
            response.data.forEach(el => {
              el = functions.removeSlashesAndDecodeStrings(el)
            })
            this.evrakListe = response.data;
            this.total = parseInt(response.toplamKayit);
            this.gelenCount = parseInt(response.gelenDosya);
            this.gidenCount = parseInt(response.gidenDosya);
            this.sonDosyaID = Math.max(...this.evrakListe.map((evrak) => evrak.yaziIsleriID), 0);
            this.evrakListe.forEach((row) => {
              row.dosyaYuklendi = false
            })
          }
          //console.log(this.evrakListe)
          this.loading = false;
        }).catch(err => {
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else if (error.status == 404) {
              this.evrakListe = [];
            } else notification.Status("errorMsg", this, error.errMsg)
          }
          this.loading = false;
        })
      } catch (e) {
        this.loading = false;
      }
    },
    filterMethod(query, item) {
      return item.label.toLowerCase().indexOf(query.toLowerCase()) >= 0;
    },
    getCariList() {
      try {
        this.cariLoading = true;
        this.cariDurumu = this.evrakDurumu == "I" ? 1 : 2
        cariService.cariListele(this.cariDurumu, this.postPage, this.sizes).then((response) => {
          if (response.status == 200) {
            localStorage.setItem("userDataDemirag", response.token);
            response.data.forEach(el => {
              el = functions.removeSlashesAndDecodeStrings(el)
            })
            this.cariListe = response.data;
          }
          this.cariLoading = false;
        }).catch(err => {
          if (err.responseJSON) {
            let error = err.responseJSON
            if (error.status == 401) {
              notification.Status(150, this);
            } else if (error.status == 404) {
              this.cariListe = [];
            } else notification.Status("errorMsg", this, error.errMsg)
          }
          this.cariLoading = false;
        })
      } catch (e) {
        this.cariLoading = false;
      }
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
      this.visibleSil = false;
      this.evrakListMain = [];

    },
    evrakRemove() {
      $('#evrakEkle .el-upload--belge-card').show();
      this.evrakListMain = [];
      this.evrakForm.evrak = [];
    },
    downloadFile(item) {
      var downloadLink = document.createElement("a");
      downloadLink.href = dosyaService.dosyaPath + item.dosyaAdi;
      downloadLink.download = item.dosyaAdi;
      downloadLink.target = "_blank";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
    dosyaSil(yaziIsleriID, durum) {
      var msg = "Evrakı silmek istediğinize emin misiniz?"
      this.openConfirmDialog(msg).then(() => {
        try {
          this.silinenID.push(yaziIsleriID)
          dosyaService.dosyaSil(yaziIsleriID).then(response => {
            if (response.status == 200) {
              localStorage.setItem("userDataDemirag", response.token)
              this.getDosyaList(durum);
            }
            notification.Status("success", this, response.msg)
          }).catch(err => {
            if (err.responseJSON) {
              let error = err.responseJSON
              if (error.status == 401) {
                notification.Status(150, this);
              } else notification.Status("warning", this, error.msg)
            } else {
              //notification.Status(503, this)
            }
          }).finally(() => {
            const index = this.silinenID.findIndex(item => item == yaziIsleriID)
            this.silinenID.splice(index, 1)
          })
        } catch (e) {
        }
      })
    },
    updatePage(data) {
      this.$store.commit('changeEvrakUpdateData', data.yaziIsleriID)
      functions.routeSayfa("Evrak Güncelle", this)
      // this.$store.commit('changeEvrakUpdateData', data.yaziIsleriID)
      //   functions.routeSayfa("Evrak Güncelle", this)
    },
    evrakAra() {
      this.postPage = 0;
      this.page = 1
      this.dateVisible = false;
      //siparisNo, adSoyad, telefon, country, city, state, baslangicTarihi, bitisTarihi, durum, baslangic, limit,
      if (this.evrakNoAra.length > 0 || this.evrakKonuAra.length > 0 || this.cariAra.length > 0 || this.tarihAra || this.evrakAdiAra.length > 0) {
        try {
          this.searchLoading = true;
          evrakService.evrakAra({
            cariAdi: this.cariAra,
            konu: this.evrakKonuAra,
            dosyaDurumu: this.evrakDurumu,
            islemTarihi: this.tarihAra,
            baslangic: this.postPage,
            limit: this.sizes,
            kayitKodu: this.evrakNoAra,

          }).then(response => {
            if (response.status == 200) {
              this.evrakListe = response.data;
              this.total = response.toplamKayit
            }
            localStorage.setItem("userDataDemirag", response.token);
            this.searchLoading = false;
          }).catch(err => {
            if (err.responseJSON) {
              let error = err.responseJSON
              if (error.status == 401) {
                notification.Status(150, this);
              } else if (error.status == 404) {
                this.evrakListe = []
              }
            } else {
              //notification.Status(503, this)
            }
            this.searchLoading = false;
          })
        } catch (e) {
          // notification.Status("danger", this, "An error occurred during the customer search process.")
          this.searchLoading = false
        }
      } else {
        this.getDosyaList();
      }
    },
    refreshPage(durum = 'I') {
      this.page = 1;
      this.postPage = 0;
      this.loading = false;
      this.evrakDurumu = durum
      this.getDosyaList(durum);
      this.stateLoading = false;
      // this.evrakDurumu = "I"

      // this.getMusteriSayisi();
      //this.getMusteriListesi();
      //this.getMusteriProjeListesi();
    },
    handleSizeChange(val) {
      this.sizes = val;
      this.getDosyaList();
    },
    pageChange(val) {
      this.postPage = (val - 1) * this.sizes;
      const durum = this.radio == 1 ? 'I' : 'O'
      this.getDosyaList(durum);
    },
    vazgec(formName) {
      this.$refs[formName].resetFields();
      this.editDialog = false;
      this.loading = false;
      this.stateLoading = false;
      this.evrakListMain = [];
      this.evrakForm.evrak = []
    },
    formatEvrakNo(row) {
      if (row.kayitKodu) {
        return row.kayitKodu
      } else {
        return '';
      }
      // if (row.kayitKodu) {
      //   const parts = row.kayitKodu.split("-");
      //   return parts[0];
      // } else {
      //   return '';
      // }
    },
    formatDate2(date) {
      const options = {day: '2-digit', month: '2-digit', year: 'numeric'};
      return new Date(date).toLocaleDateString('tr-TR', options);
    },
    changeMusteriDurum(selection, durum) {
      this.$confirm("Müşterinin durumunu güncellemek istediğinizden emin misiniz?", this.$t("src.views.apps.genel.uyari"), {
        confirmButtonText: this.$t("src.views.apps.genel.yes"),
        cancelButtonText: this.$t("src.views.apps.genel.no"),
        type: 'warning'
      }).then(() => {
        try {
          this.stateLoading = true;
          var item = {durum: durum}
          cariService.musteriGuncelle(selection.musteriID, (item)).then(response => {
            if (response.status == 200) {
              // this.getMusteriListesi();
              //this.getMusteriProjeListesi();
            }
            this.stateLoading = false;
            notification.Status("success", this, response.msg);
            localStorage.setItem("userDataDemirag", response.token);
          }).catch(err => {
            if (err.responseJSON) {
              let error = err.responseJSON
              if (error.status == 401) {
                notification.Status(150, this);
              } else notification.Status("errorMsg", this, error.errMsg)
            } else {
              //notification.Status(503, this)
            }
            this.stateLoading = false;
          })
        } catch (e) {
          // notification.Status("success", this, "An error occurred while fetching the customer number.");
          this.stateLoading = false;
        }
      })
    },
    routeCari(name, scope) {
      if (scope) {
        this.$store.commit('changeCariUpdateData', scope);
      }
      functions.routeSayfa(name, this);
    },
    indexMethod(index) {
      return ((this.page - 1) * 10) + index + 1;
    },
    handleChange(event) {
      this.evrakDurumu = event;
      this.page = 1;
      this.postPage = 0;
      this.getDosyaList();
      document.querySelector('.scrollable').scrollTo({top: 0, behavior: 'smooth'});
      this.cariAdiAra = ""
      this.unvanAra = ""
      this.adresAra = ""
      this.telefonAra = ""
      this.epostaAra = ""
    },
    formatDate(row, column) {
      const date = row.islemTarihi;
      return moment(date, 'YYYY-MM-DD').format('DD.MM.YYYY');
    },
  }
}

</script>

<style lang="scss">
.sunucu-dialog {
  .el-dialog__body {
    padding-top: 0 !important;
  }
}

.el-table .info-row {
  background: rgba(125, 199, 225, 0.45);
}

.el-table .error-row {
  background: rgba(249, 0, 26, 0.08);
}

.el-table .success-row {
  background: rgba(3, 249, 0, 0.08);
}

.el-table .warning-row {
  background: rgba(245, 249, 0, 0.08);
}
</style>
<style lang="scss" scoped>
.upload-tooltip {
  width: 44% !important;
}

.upload-btn {
  height: 40px !important;
  background-color: red;
  border: none;
}

.download-btn {
  height: 40px !important;
  background-color: #00A9FF;
  border: none;
}

@media screen and (max-width: 1200px) {
  .islemler {
    margin: 20px 0 20px 0;
    display: inline-flex !important;
  }
}

.refresh {
  color: #fff;
  float: right;
  padding: 0 !important;
  transition: all 0.5s;

}

.refresh:hover {
  transform: rotate(360deg);
}

.el-pagination {
  margin-top: 20px;
  float: right;
}

.el-radio-button--mini .el-radio-button__inner label {
  position: relative;
  bottom: 5px;
}

.kaldirilmis {
  background: #ec205f;
  color: white;
  font-weight: bold;
  font-size: 16px;
  padding: 10px
}
</style>
<style lang="scss">
.slide-fade-enter-active {
  transition: all .3s ease;
}


@media (min-width: 768px) {
  .el-radio-button--mini .el-radio-button__inner {
    padding: 0 10px !important;
    font-size: 11px;
    border-radius: 0;
  }
}


.slide-fade-leave-active {
  transition: all .3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter,
.slide-fade-leave-to

  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}
</style>
<style>
.el-badge__content {
  background-color: red !important;
  color: white;
  width: 20px;
  height: 20px;
  padding: 0;
  border-radius: 50%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 14px;
  font-weight: 450;
  margin-bottom: -20px !important;
}

.evrak .el-badge__content.is-fixed {
  position: absolute;
  top: 0;
  right: 10px;
  -webkit-transform: translateY(-50%) translateX(100%);
  transform: translateY(-50%) translateX(-550%);
}

.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  color: #FFFFFF;
  text-align: left;
  /* padding-left: 0; */
  /*background-color: #90c4a1;*/
  background-color: #3b94bd;
  border-color: #3b94bd;
  -webkit-box-shadow: -1px 0 0 0 #3b94bd;
  box-shadow: -1px 0 0 0 #3b94bd;
}


.indir {
  margin-left: 2px !important;
  padding-right: 10px !important;
  padding-top: 5px;
  padding-bottom: 0 !important;
  margin-bottom: 1px !important;
  position: relative;
  display: inline-block;
}

.upload {
  line-height: 40px;
}

.indir .mdi-download {
  font-size: 23px;
}

.indir .indir-text {
  position: absolute;
  top: 50%;
  left: 40%;
  transform: translateY(-50%) translateX(-5px);
  padding: 5px 20px;
  border-radius: 4px;
  opacity: 0;
  transition: opacity 0.3s, transform 0.3s;
}


.indir:hover .indir-text {
  opacity: 100;
  transform: translateY(-50%) translateX(0);
  transition-duration: 0.9s;
  color: red;
}


.el-button--mini {
  padding: 7px 5px;
  font-size: 16px;
  border-radius: 3px;
}
</style>